module.exports = __webpack_public_path__ + "img/Collegio_alla_querc_1.3e9889ef.jpg";